export interface BalancePillProps {
  balance: number;
}

const formatter = new Intl.NumberFormat("en-IN");

export function BalancePill({ balance }: BalancePillProps) {
  return (
    <div className="jaiho-balance-pill">
      <span className="jaiho-balance-pill__dot" aria-hidden />
      <span className="jaiho-balance-pill__amount">{formatter.format(balance)}</span>
      <span className="jaiho-balance-pill__label">credits</span>
    </div>
  );
}
